import React from 'react'
import Playlist from './Playlist'
import VideoJS from './VideoJS'



const Player = ({ index, onClickPlaylistItem, onEnd, playlist, textChanged, captionOn }) => {
  return (
    <div className="player">
      <div className="video-outer">
        <div className="video-inner">
          <VideoJS
            onEnded={onEnd}
            textChanged={textChanged}
            autoplay={true}
            controls={true}
            fluid={true}
            sources={[{ src: playlist[index].src, type: 'video/mp4' }]}
            captions={playlist[index].captions}
            captionOn={captionOn}
            tracks={[ {
              src: playlist[index].captions[0],
              controlBar: { volumePanel: { inline: false } },
              kind: 'captions',
              label: 'English',
              mode: 'disabled',
              tech: 'Html5',
              default: captionOn
            }]}
          />
        </div>
      </div>
      <Playlist index={index} list={playlist} onClickItem={onClickPlaylistItem} />
    </div>
  )
}

export default Player




// WEBPACK FOOTER //
// ./src/components/Player.js